import { FaFileCode, FaArrowRight } from "react-icons/fa";
import { STATUS_MAP_CHANGE_ACTION } from "../../../_Catalogs.Views";
import { StatusBadge } from "../../../../../_CORE/APP/Templates/_UI/Status/_index";
import { AppCodeBlock } from "../../../../../_CORE/APP/Templates/_UI/CodeBlock/_index";

export const ChangeDiffView = ({ change, hasFilePath = true, actions = null }) => {

    const HAS_BEFORE = !!change.codeBefore;
    const HAS_AFTER = !!change.codeAfter;

    return (
        <article className="LStudio__app_change">

            <header className="LStudio__app_change_head">

                {
                    hasFilePath && (
                        <code className="LStudio__app_change_file">
                            <FaFileCode aria-hidden="true" /> {change.filePath}
                        </code>
                    )
                }

                <StatusBadge status={change.action} map={STATUS_MAP_CHANGE_ACTION} size="sm" />

                <span className="LStudio__app_change_lang">{change.language}</span>

                {actions && <div className="LStudio__app_change_actions">{actions}</div>}

            </header>

            {change.description && <p className="LStudio__app_change_desc">{change.description}</p>}

            <div className="LStudio__app_change_diff" data-single={!HAS_BEFORE || !HAS_AFTER}>

                {
                    HAS_BEFORE && (
                        <div className="LStudio__app_change_side" data-side="before">
                            <span className="LStudio__app_change_side_label">Código anterior</span>
                            <AppCodeBlock code={change.codeBefore} language={change.language} isPretty={false} />
                        </div>
                    )
                }

                {HAS_BEFORE && HAS_AFTER && <FaArrowRight className="LStudio__app_change_arrow" aria-hidden="true" />}

                {
                    HAS_AFTER && (
                        <div className="LStudio__app_change_side" data-side="after">
                            <span className="LStudio__app_change_side_label">Código nuevo</span>
                            <AppCodeBlock code={change.codeAfter} language={change.language} isPretty={false} />
                        </div>
                    )
                }

            </div>

        </article>
    );
};
